import React from "react";
import PriceInMillions from "../../ui-building-blocks/numbers/PriceInMillions";
import AbbreviatedMillionNumberFormat from "../../ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";
import Styled from "components/operations/style";
import Teams from "api/Teams";
import { view } from "@risingstack/react-easy-state";

const hexToRgba = (hex, opacity = 1) => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");
    return (
      "rgba(" +
      [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
      "," +
      opacity +
      ")"
    );
  }
  throw new Error("Bad Hex");
};

function InHouseProduction({ products = [] }) {
  const productsFiltered = products.filter(
    i =>
      i.available_for_sale > 0 ||
      i.beginning_inventory > 0 ||
      i.units_produced > 0
  );
  const showProducts = productsFiltered.length > 0;

  return (
    <Styled.Table.Wrapper>
      <Styled.Table.Title>In-House Production</Styled.Table.Title>

      <Styled.Table.Table
        rowColor={hexToRgba(Teams.currentTeamColorLevel1(), 0.3)}
      >
        <table>
          <thead>
            <tr>
              <th>Product</th>
              <th>Beg. Inventory</th>
              <th>Units Produced</th>
              <th>Available Units for Sale</th>
              <th>Cost Per Unit</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {products.map((product, i) => (
              <tr key={i}>
                <td>{product.product_name}</td>
                {showProducts === true
                  ? [
                      <td key={0}>
                        <PriceInMillions
                          price={product.beginning_inventory}
                          prefix=""
                          decimalPrecision={3}
                        />
                      </td>,
                      <td key={1}>
                        <AbbreviatedMillionNumberFormat
                          value={product.units_produced}
                          forceConvert={true}
                          decimalPrecision={3}
                        />
                      </td>,
                      <td key={2}>
                        <AbbreviatedMillionNumberFormat
                          value={product.available_for_sale}
                          forceConvert={true}
                          decimalPrecision={3}
                        />
                      </td>,
                      <td key={3}>${product.cost_per_unit.toFixed(2)}</td>
                    ]
                  : i === 0 && (
                      <td colSpan="6" rowSpan={products.length}>
                        No units in inventory
                      </td>
                    )}
              </tr>
            ))}
          </tbody>
        </table>
      </Styled.Table.Table>
    </Styled.Table.Wrapper>
  );
}

export default view(InHouseProduction);



// WEBPACK FOOTER //
// ./src/components/operations/decisions/in-house-production.js